import React from 'react';
import pluralize from '../../_utils/tools/pluralize';

export default function UploadFailureMessage({ failedUploadCount }) {
  return (
    <div
      data-test-id="upload-failure-message"
      className="alert alert-danger p-2 w-50 mx-auto mt-2"
      role="alert">
      <i className="fas fa-exclamation-circle fa-lg mr-2 text-danger" />
      {failedUploadCount} {pluralize('photo', failedUploadCount)} failed to
      upload
    </div>
  );
}
